import { render } from "./MessageView.vue?vue&type=template&id=6cfd17a0&ts=true"
import script from "./MessageView.vue?vue&type=script&lang=ts"
export * from "./MessageView.vue?vue&type=script&lang=ts"

import "./MessageView.vue?vue&type=style&index=0&id=6cfd17a0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__